import { AcquisitionPanel } from '@/components/panels/AcquisitionPanel';
import { InfoPanel } from '@/components/panels/InfoPanel';
import { ProjectionPanel } from '@/components/panels/ProjectionPanel';
import { TeamCostsPanel } from '@/components/panels/TeamCostsPanel';
import { TiersPanel } from '@/components/panels/TiersPanel';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function ConfigPanel({ defaultTab = 'info' }: { defaultTab?: string }) {
  return (
    <Tabs defaultValue={defaultTab}>
      <TabsList className="grid !h-auto w-full grid-cols-3 sm:grid-cols-5">
        <TabsTrigger value="info">Informations</TabsTrigger>
        <TabsTrigger value="team">Équipe & Coûts</TabsTrigger>
        <TabsTrigger value="tiers">Paliers</TabsTrigger>
        <TabsTrigger value="acquisition">Acquisition</TabsTrigger>
        <TabsTrigger value="projection">Projection</TabsTrigger>
      </TabsList>
      <TabsContent value="info">
        <InfoPanel />
      </TabsContent>
      <TabsContent value="team">
        <TeamCostsPanel />
      </TabsContent>
      <TabsContent value="tiers">
        <TiersPanel />
      </TabsContent>
      <TabsContent value="acquisition">
        <AcquisitionPanel />
      </TabsContent>
      <TabsContent value="projection">
        <ProjectionPanel />
      </TabsContent>
    </Tabs>
  );
}
